var _rect, _path, _path2, _path3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmailCardIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666667,
    y: 0.666667,
    width: 38.6667,
    height: 38.6667,
    rx: 4.66667,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1042 20.638L10.2083 13.7214L9.49219 13.1641L10.2109 13.724V27.2969H29.7943V13.724L20.8932 20.638C20.6374 20.8368 20.3227 20.9447 19.9987 20.9447C19.6747 20.9447 19.36 20.8368 19.1042 20.638Z",
    fill: "#E0E7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4922 11.8486L30.5156 13.1637L29.7969 13.7236L30.5182 13.1637L29.4948 11.8486H29.4922Z",
    fill: "#E0E7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8359 10.8389H9.16927C8.70833 10.8389 8.33594 11.2113 8.33594 11.6722V28.3389C8.33594 28.7998 8.70833 29.1722 9.16927 29.1722H30.8359C31.2969 29.1722 31.6693 28.7998 31.6693 28.3389V11.6722C31.6693 11.2113 31.2969 10.8389 30.8359 10.8389ZM28.375 12.7165L20.0026 19.2243L11.6302 12.7165H28.375ZM29.7943 13.7243V27.2972H10.2109V13.7243L9.49219 13.1644L10.2083 13.7217L19.1042 20.6383C19.36 20.8371 19.6747 20.945 19.9987 20.945C20.3227 20.945 20.6374 20.8371 20.8932 20.6383L29.7943 13.7243L30.513 13.1644L29.4896 11.8493H29.4922L30.5156 13.1644L29.7943 13.7243Z",
    fill: "#6366F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.666667,
    y: 0.666667,
    width: 38.6667,
    height: 38.6667,
    rx: 4.66667,
    stroke: "#E5E7EB",
    strokeWidth: 1.33333
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmailCardIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email-card-icon.19a3276ef23f922d6cf794f274c6c2e0.svg";